export const NavbarText = {
  key1: 'Products',
  key2: 'Industries & Cases',
  key3: 'Pricing',
  key4: 'Developers',
  key5: 'Help & Guides',
  key6: 'Login',
  key7: 'Contact'
}

export default NavbarText;



// WEBPACK FOOTER //
// ./src/input-text/en/navbar.js